import { createElementVNode as _createElementVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, withModifiers as _withModifiers, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "modal-wrapper" }
const _hoisted_2 = { class: "input-row" }
const _hoisted_3 = { class: "input-wr input-price-wr" }
const _hoisted_4 = ["disabled"]
const _hoisted_5 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock($setup["Modal"], {
    isOpen: $props.isOpen,
    showClose: false,
    onClose: $setup.close
  }, {
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _cache[4] || (_cache[4] = _createElementVNode("div", { class: "modal-title" }, "Create Folder", -1)),
        _createElementVNode("form", {
          class: "default-form",
          onSubmit: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["prevent"]))
        }, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _cache[3] || (_cache[3] = _createElementVNode("label", { class: "label" }, "Folder Name", -1)),
              _withDirectives(_createElementVNode("input", {
                class: _normalizeClass(["input", { error: $setup.v$.foldername.$error }]),
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.form.foldername) = $event)),
                type: "text",
                placeholder: "Folder Name",
                onBlur: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => ($setup.v$.foldername.$touch && $setup.v$.foldername.$touch(...args)))
              }, null, 34), [
                [
                  _vModelText,
                  $setup.form.foldername,
                  void 0,
                  { trim: true }
                ]
              ])
            ])
          ])
        ], 32),
        _createElementVNode("div", {
          class: _normalizeClass(["controls", { 'disabled-block ': $setup.disabled }])
        }, [
          _createElementVNode("button", {
            class: "button default cancel",
            onClick: $setup.close,
            disabled: $setup.disabled
          }, "Cancel", 8, _hoisted_4),
          _createElementVNode("button", {
            class: "button default primary save",
            onClick: $setup.create,
            disabled: $setup.disabled
          }, "Create", 8, _hoisted_5)
        ], 2)
      ])
    ]),
    _: 1
  }, 8, ["isOpen"]))
}